<style lang="scss"></style>

<template>
  <!-- eslint-disable max-len -->
  <div class="dates-page theme-color-wrapper p-2">
    <div class="row">
      <div class="col-12">
        <h2 class="font-weight-bold" cy="page-title">
          Restricted Booking Dates
        </h2>
      </div>
    </div>
    <div class="row">
      <div class="col-12 d-flex justify-content-between">
        <router-link :to="{ name: 'dashboard' }" class="body-text">
          &laquo; Back to dashboard
        </router-link>

        <b-btn variant="primary" @click="$bvModal.show('modal-add-date')">
          Add Date
        </b-btn>
      </div>
    </div>
    <section class="row mt-3">
      <section class="col-12 d-flex align-center">
        <section class="row d-flex align-items-center full-width">
          <section class="col-4">
            <label>Name</label>
            <b-form-input type="text" placeholder="Search for date by name" cy="dates-search"
                   class="form-control form-control-sm" @keyup.enter="getDates()" v-model="filters.name"/>
          </section>
          <section class="col-4">
            <label>Sort</label>
            <select @change="getDates()" v-model="filters.sort" class="form-control form-control-sm">
              <option v-for="sort in sorts" :key="sort.value" :value="sort.value">{{sort.text}}</option>
            </select>
          </section>
          <section class="col-4">
            <label class="d-block" style="opacity: 0">Search</label>
            <b-btn variant="primary" @click="getDates()" cy="search-btn">Search</b-btn>
          </section>
        </section>
      </section>
    </section>
    <div class="row mt-3" v-if="!loading">
      <div class="col-12">
        <b-table
          hide-default-footer
          disable-sort
          :items="dates"
          :fields="headers"
          :current-page="currentPage"
          :per-page="null"
          class="data-table" cy="dates-table"
        >
          <template #cell(start_date)="data">
           {{data.item.start_date | formatDate}}
          </template>

          <template  #cell(end_date)="data">
            {{data.item.end_date | formatDate}}
          </template>

          <template #cell(actions)="data">
            <b-dropdown class="m-0"  variant="link" right toggle-class="text-decoration-none" no-caret>
              <template #button-content>
                <i class="fas fa-ellipsis-v"></i>
              </template>
              <b-dropdown-item-button class="full-nested-btn"
                                      @click="showDateModal('modal-update-date', data.item)">
                Update
              </b-dropdown-item-button>
              <b-dropdown-item-button class="full-nested-btn"
                                      @click="deleteDate(data.item)">
                Delete
              </b-dropdown-item-button>
            </b-dropdown>
          </template>
        </b-table>
        <b-row v-if="dates && dates.length > 0">
          <b-col md="6" class="my-1">
            <b-pagination @change="getDates" :total-rows="totalRows" :per-page="filters.limit" v-model="currentPage" class="my-0" />
          </b-col>
        </b-row>
        <div v-if="!dates || dates.length === 0">
          <p class="mb-0">No Restricted Dates</p>
        </div>
     </div>

    </div>
    <div class="row" v-else>
      <p>Getting restricted dates...</p>
    </div>

    <b-modal id="modal-add-date" title="Add restricted date" hide-footer>
      <add-restricted-date @close="closeModals()" @refresh="getDates()"></add-restricted-date>
    </b-modal>

    <b-modal id="modal-update-date" title="Update restricted date" hide-footer>
      <update-restricted-date v-if="selectedDate" :existing="selectedDate" @close="closeModals()" @refresh="getDates()"></update-restricted-date>
    </b-modal>
  </div>
  <!-- eslint-enable -->
</template>

<script>
  import moment from 'moment';
  import BookingRestrictedDateService from '../../services/BookingRestrictedDateService';
  import AddRestrictedDate from './sections/AddRestrictedDate.vue';
  import UpdateRestrictedDate from './sections/UpdateRestrictedDate.vue';

  export default {
    props: {},
    components: {
      AddRestrictedDate,
      UpdateRestrictedDate,
    },
    data() {
      return {
        loading: true,
        dates: [],
        filters: {
          name: '',
          skip: 10,
          limit: 10,
          sort: 'start_date',
        },
        currentPage: 1,
        totalRows: 10,
        headers: [
          { label: 'Name', key: 'name' },
          { label: 'Start Date', key: 'start_date' },
          { label: 'End Date', key: 'end_date' },
          { label: 'Actions', key: 'actions' },
        ],
        selectedDate: null,
        sorts: [
          {text: 'Upcoming Start', value: 'start_date'},{text: 'Furthest Start', value: '-start_date'},
          {text: 'Upcoming End', value: 'end_date'},{text: 'Furthest end', value: '-end_date'},
        ],
      };
    },
    mounted() {
      this.getDates();
    },
    methods: {
      getDates() {
        this.filters.skip = (this.currentPage - 1) * this.filters.limit;

        BookingRestrictedDateService.getRestrictedDates(this.filters).then((res) => {
          this.dates = res.data.data.map((item) => {
            const date = { ...item };
            date.start_date = moment(date.start_date).format('YYYY-MM-DD');
            date.end_date = moment(date.end_date).format('YYYY-MM-DD');
            return date;
          });
          this.totalRows = res.data.count;
          this.closeModals();
        }).catch((err) => {
          console.log('Error getting restricted dates', err);
          this.$toasted.error('Error getting restricted dates. Please refresh the page');
        }).finally(() => {
          this.loading = false;
        });
      },
      backRoute() {
        this.$router.go(-1);
      },
      closeModals() {
        this.$bvModal.hide('modal-add-date');
        this.$bvModal.hide('modal-update-date');
        this.$bvModal.hide('modal-delete-date');
      },
      showDateModal(modalName, date) {
        this.selectedDate = date;
        this.$bvModal.show(modalName);
      },
      deleteDate(date) {
        this.$swal({
          title: 'Are you sure?',
          text: `Are you sure you want to delete date ${date.name}?`,
          icon: 'info',
          buttons: true,
        }).then((value) => {
          if(value) {
            BookingRestrictedDateService.deleteDate(date._id).then(() => {
              this.$toast.success('Restricted Date successfully deleted', {
                toastClassName: ['toast-std', 'success-toast'],
              });
              this.getDates(); // refresh
            }).catch((err) => {
              console.log('error deleting date', err.response);
              this.$toast.error('There was a problem deleting this date, please refresh and try again', {
                toastClassName: ['toast-std', 'warning-toast'],
              });
            });
          }
        });
      },
    },
  };
</script>
